module.exports = __webpack_public_path__ + "media/images/ofn-o-50a8225e5aeec554924f2eb8ddf12ed2.svg";